import React from 'react';
import PropTypes from 'prop-types';
import DefaultSelect from 'components/DefaultSelect';

const ValidateSelectV2 = ({ error, onChange, value, disabled, isRequired, showEmpty }) => (
  <DefaultSelect
    error={error} showEmpty={showEmpty} isRequired={isRequired}
    label="Validado" name="validate"
    onSelect={e => onChange(e.target.value ? e.target.value : null)}
    options={[
      { id: 'AGUARDANDO_VALIDACAO', descricao: 'Aguardando Validação' },
      { id: 'VALIDADO', descricao: 'Validado' },
      { id: 'INVALIDADO', descricao: 'Invalidado' },
    ]}
    value={value}
    handlerOption={option => option.descricao}
    disabled={disabled}
  />
);

ValidateSelectV2.propTypes = {
  error: PropTypes.bool, onChange: PropTypes.func, value: PropTypes.string,
  disabled: PropTypes.bool, isRequired: PropTypes.any, showEmpty: PropTypes.bool
};
ValidateSelectV2.defaultProps = { value: '', showEmpty: false, onChange: () => {} };
export default ValidateSelectV2;
